<template>
  <div
    :class="$style['promotion']"
    @click="onClick">
    <img src="/images/promotions/warsocks/warsocks-logo.svg?url" :class="$style['promotion__title']">
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/warsocks/warsocks.webp');
  position: relative;

  &__title {
    position: absolute;
    height: 20.5%;
    bottom: 5%;
    right: 5%;
    transform: rotate(-6deg);
  }
}
</style>
